/**
 *Transaction filter component, with search and avilable chian list.
 * set parent states passed as props
 * Author: Nauman Sukhera
 * Date: 14 Nov, 2023
 */
import React from 'react';
import { Container, Dropdown, Row, Col, Button, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { config } from '../../config';
import FilterIcon from '../../assets/images/icon-filter.svg';

const TransactionFilter = ({
  selectedChain,
  setSelectedChain,
  isFilter,
  setIsFilter,
  search,
  setSearch
}) => {
  const resetHandler = () => {
    setSelectedChain('');
    setIsFilter(false);
    setSearch('');
  };
  return (
    <>
      <Container fluid className="filters-wrapper mb-3">
        <Row className="justify-content-between">
          <Col xl={5} sm={7} className="mb-sm-0 mb-2">
            <div className="dropdown-wrapper">
              <Dropdown className="w-50">
                <Dropdown.Toggle
                  className="bg-white text-black text-start text-wrap w-100 px-sm-3 px-2 py-2"
                  id="dropdown-basic"
                >
                  {selectedChain ? selectedChain.label : 'All Chains'}
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                  {config.chains.map((chain) => (
                    <Dropdown.Item
                      key={chain.id}
                      value={chain}
                      onClick={() => {
                        setSelectedChain(chain);
                        setIsFilter(false);
                      }}
                    >
                      {chain.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Col>
          <Col xl={5} lg={5}>
            <div className="d-flex justify-content-end">
              <div className="dropdown-search-box search-box position-relative mb-md-0 mb-2 me-4">
                <input
                  placeholder="Search"
                  className="w-100 h-100"
                  value={search.value}
                  onChange={(event) => {
                    setIsFilter(false);
                    setSearch(event.target.value);
                  }}
                />
              </div>
              <div className="btn-wrapper d-flex align-items-center">
                {isFilter === false ? (
                  <Button
                    className="gradient-btn h-100 d-flex align-items-center"
                    onClick={() => {
                      setIsFilter(true);
                    }}
                  >
                    Apply
                    <Image className="ms-3" src={FilterIcon} alt="filter icon" />
                  </Button>
                ) : (
                  <Button
                    className="btn-close ms-3"
                    onClick={() => {
                      resetHandler();
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </Button>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TransactionFilter;
